"use client";
import s from "./ExtraFeaturesSidebar.module.scss";
import Image from "next/image";
import { CORE_API_URL, SITE_DOMAIN } from "@/shared/config/constants";
import { useEffect } from "react";
import { SpriteIcon } from "@/components/UI/SpriteIcon";
import { ExtraFeatureAnySetting } from "@/types/orderForm";
import { getExtraFeatureName, useCalculatorForm } from "@/lib/priceCalculator";
import IconAngleRight from "public/img/icons/sprite/angle-right.svg";

type ExtraFeaturesSidebarProps = {
  extraFeatures: ExtraFeatureAnySetting[];
};

const getExtraFeatureDescription = ({
  flatSurcharge,
  percentageSurcharge,
}: ExtraFeatureAnySetting): string => {
  if (flatSurcharge && percentageSurcharge) {
    return `$${flatSurcharge} +${percentageSurcharge}% to the page price`;
  } else if (flatSurcharge) {
    return `$${flatSurcharge}`;
  } else if (percentageSurcharge) {
    return `+${percentageSurcharge}% to the page price`;
  } else {
    return "";
  }
};

export const ExtraFeaturesSidebar = ({ extraFeatures }: ExtraFeaturesSidebarProps) => {
  const { submit, formValues, updateValues } = useCalculatorForm(String(SITE_DOMAIN), String(CORE_API_URL));

  const handleExtraFeatureClick = (feature: ExtraFeatureAnySetting) => {
    updateValues({ selectedFeatures: [feature.idExtraFeatureType] });
  };

  useEffect(() => {
    if (formValues.selectedFeatures?.length) submit();
  }, [formValues.selectedFeatures, submit]);

  return (
    <div className={s.wrapper}>
      <Image
        src="/img/icons/shared/premium-features-icon.svg"
        alt=""
        width={32}
        height={32}
        className={s.icon}
      />
      <strong className={s.heading}>Try premium features</strong>
      <p className={s.desc}>Enhance your paper quality with our premium services for additional cost.</p>
      <ul className={s.list}>
        {extraFeatures.map((feature) => (
          <li
            key={`${feature.id}-${feature.idExtraFeatureType}`}
            className={s.extraFeature}
            onClick={() => handleExtraFeatureClick(feature)}
          >
            <Image
              src={`/img/icons/shared/extra-features/${feature.idExtraFeatureType}.svg`}
              alt=""
              width={36}
              height={36}
              className={s.img}
            />
            <div className={s.featureDesc}>
              <div>
                <strong className={s.featureName}>
                  {feature.customerName || getExtraFeatureName(feature.idExtraFeatureType)}
                </strong>
                <span className={s.featureText}>{getExtraFeatureDescription(feature)}</span>
              </div>
              <SpriteIcon icon={IconAngleRight} width={24} height={24} />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
